import React from "react";
import { Box, Typography } from "@mui/material";
import { StepContainer } from "../styles";
import { stepContent } from "../content";
import RoutePricingDiagram from "../RoutePricingDiagram";

const RoutePricingStep = () => {
  const content = stepContent.routePricing;

  return (
    <StepContainer>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {content.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          {content.subtitle}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, fontStyle: "italic" }}
        >
          {content.explanation}
        </Typography>
      </Box>

      {/* Diagram */}
      <RoutePricingDiagram />

      {/* Key Point */}
      <Box
        sx={{
          mt: 3,
          p: 2.5,
          borderRadius: 2,
          bgcolor: "primary.main",
          color: "white",
          textAlign: "center",
        }}
      >
        <Typography variant="body1" fontWeight={600} color={"white"}>
          {content.keyPoint}
        </Typography>
      </Box>
    </StepContainer>
  );
};

export default RoutePricingStep;
